import {
  LOWER_BOUND_RULE_OPERATORS,
  RULE_FIELD,
  RULE_OPERATOR,
  UPPER_BOUND_RULE_OPERATORS,
} from "constants/ruleEngine";
import { ConditionResult, RuleConditionRow } from "types/Models/ruleEngine";

const findBound = (
  amountCondition: ConditionResult,
  rows: Partial<RuleConditionRow>[],
  operatorTypes: string[]
) => {
  const operators = amountCondition.available_operators.filter(
    ({ operator_type }) => operatorTypes.includes(operator_type)
  );
  const index = rows.findIndex(
    ({ field, conditionFunction, conditionValue }) =>
      field === amountCondition.uuid &&
      conditionValue !== "" &&
      operators.some(({ uuid }) => uuid === conditionFunction)
  );
  const operator = operators.find(
    ({ uuid }) => uuid === rows[index]?.conditionFunction
  );

  if (index === -1 || !operator) return null;

  return {
    index,
    value: Number(rows[index].conditionValue),
    type: operator.operator_type,
  };
};

export const getInvalidRuleAmountRangeRows = (
  conditions: ConditionResult[],
  rows: Partial<RuleConditionRow>[]
): number[] => {
  const amountCondition = conditions.find(
    ({ name }) => name === RULE_FIELD.AMOUNT
  );

  if (!amountCondition) return [];

  const lower = findBound(amountCondition, rows, LOWER_BOUND_RULE_OPERATORS);
  const upper = findBound(amountCondition, rows, UPPER_BOUND_RULE_OPERATORS);

  if (!lower || !upper) return [];

  const isInclusive =
    lower.type === RULE_OPERATOR.IS_MORE_THAN_EQUAL_TO &&
    upper.type === RULE_OPERATOR.IS_LESS_THAN_EQUAL_TO;
  const isInvalid = isInclusive
    ? lower.value > upper.value
    : lower.value >= upper.value;

  return isInvalid ? [lower.index, upper.index] : [];
};
